// Stage 0 uses loam, stages 1-3 use moss. Verbatim from the design handoff so web matches mobile PlantIcon.
export type Stage = 0 | 1 | 2 | 3

export default function Plant({
  stage = 0,
  size = 24,
  color,
  soil = true,
  dim = false,
  soilColor,
}: {
  stage?: Stage
  size?: number
  color?: string
  soil?: boolean
  dim?: boolean
  soilColor?: string
}) {
  const c = dim ? 'var(--ink-4)' : color || 'var(--moss)'
  const sc = soilColor || 'var(--loam)'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      style={{ flexShrink: 0, display: 'block' }}
      aria-hidden="true"
    >
      {soil && <ellipse cx="20" cy="35" rx="13" ry="1.8" fill={sc} opacity="0.55" />}
      {stage === 0 && (
        <g>
          <ellipse cx="20" cy="33.5" rx="3.5" ry="2.4" fill={sc} />
          <path d="M17.5 33 Q20 30.5 22.5 33" stroke={sc} strokeWidth="1.2" fill="none" opacity="0.55" />
        </g>
      )}
      {stage === 1 && (
        <g>
          <path d="M20 34 V25" stroke={c} strokeWidth="1.8" strokeLinecap="round" />
          <path d="M20 27 Q14 23 12 27 Q15 28 20 27 Z" fill={c} opacity="0.95" />
          <path d="M20 27 Q26 23 28 27 Q25 28 20 27 Z" fill={c} opacity="0.95" />
        </g>
      )}
      {stage === 2 && (
        <g>
          <path d="M20 34 V14" stroke={sc} strokeWidth="2" strokeLinecap="round" />
          <path d="M20 22 Q12 19 9 23 Q14 25 20 23 Z" fill={c} />
          <path d="M20 19 Q28 16 31 20 Q26 23 20 21 Z" fill={c} />
          <path d="M20 16 Q14 12 12 14 Q16 16 20 16" fill={c} opacity="0.85" />
          <path d="M20 14 Q25 9 28 11 Q24 14 20 14" fill={c} opacity="0.85" />
        </g>
      )}
      {stage === 3 && (
        <g>
          <path d="M8 33 V24" stroke={sc} strokeWidth="1.4" strokeLinecap="round" />
          <circle cx="8" cy="22" r="5" fill={c} opacity="0.78" />
          <path d="M32 33 V24" stroke={sc} strokeWidth="1.4" strokeLinecap="round" />
          <circle cx="32" cy="22" r="5" fill={c} opacity="0.78" />
          <path d="M20 34 V18" stroke={sc} strokeWidth="2.4" strokeLinecap="round" />
          <circle cx="20" cy="14" r="8" fill={c} />
          <circle cx="14" cy="17" r="5.4" fill={c} />
          <circle cx="26" cy="17" r="5.4" fill={c} />
          <circle cx="20" cy="9" r="4.6" fill={c} opacity="0.92" />
        </g>
      )}
    </svg>
  )
}
